import { LucideIcon, TriangleAlertIcon } from "lucide-react";

import { cn } from "@/lib/utils";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Progress } from "@/components/ui/progress";
import {
  Item,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from "../ui/item";

function StepProgress({
  currentStep,
  steps,
}: {
  currentStep: number;
  steps: {
    title: string;
    description: string;
    icon: LucideIcon;
    hasError?: boolean;
  }[];
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Progression</CardTitle>

        <Progress
          className="mt-1 h-4"
          value={(currentStep / steps.length) * 100}
        />
        <p className="text-sm text-gray-600">
          Étape {currentStep} sur {steps.length}
        </p>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {steps.map((step, index) => (
            <Item
              key={index}
              className={cn(
                "group bg-muted data-[highlighted=true]:bg-primary data-[highlighted=true]:text-primary-foreground gap-2 p-2",
                step.hasError && "items-stretch gap-0 pr-0",
              )}
              data-highlighted={currentStep > index}
            >
              <ItemMedia className="py-1">
                <step.icon className="size-4 shrink-0" aria-hidden />
              </ItemMedia>
              <ItemContent className="gap-0 py-1">
                <ItemTitle>{step.title}</ItemTitle>
                <ItemDescription className="group-data-[highlighted=true]:text-white">
                  {step.description}
                </ItemDescription>
              </ItemContent>
              {step.hasError ? (
                <TriangleAlertIcon className="text-destructive flex size-8 w-14 shrink-0 items-center justify-center" />
              ) : null}
            </Item>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

export { StepProgress };
